var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 39.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#b8b9b9;stroke-width:0.3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1197",
    "data-name": "Group 1197"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1196",
    "data-name": "Group 1196"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2009",
    "data-name": "Path 2009",
    className: "cls-1",
    d: "M13.49,20.49V14.6a1.32,1.32,0,0,1,1-1.37.2.2,0,0,0,.11-.11,1.3,1.3,0,0,1,1.32-1h9.24a1.3,1.3,0,0,1,1.37,1.23v12a1.31,1.31,0,0,1-1,1.3.24.24,0,0,0-.13.13,1.3,1.3,0,0,1-1.3,1H14.86a1.3,1.3,0,0,1-1.37-1.22V20.49Zm9.12-6.77H14.85a.77.77,0,0,0-.84.71v12a.79.79,0,0,0,.75.82h9.37a.78.78,0,0,0,.82-.74V16.06H23c-.27,0-.35-.08-.35-.36v-1c0-.33,0-.66,0-1Zm-7.49-.52h7.65a.46.46,0,0,1,.36.14c.72.74,1.45,1.47,2.18,2.19a.48.48,0,0,1,.16.39V26.15a.73.73,0,0,0,.52-.73V13.49a.73.73,0,0,0-.39-.7,1,1,0,0,0-.46-.11H15.86a.72.72,0,0,0-.74.52Zm9.41,2.33-1.39-1.39v1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2013",
    "data-name": "Path 2013",
    className: "cls-1",
    d: "M20.78,16.48a1.3,1.3,0,1,1-1.3-1.3h0A1.31,1.31,0,0,1,20.78,16.48Zm-.52,0a.79.79,0,0,0-.77-.79.78.78,0,1,0,.77.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2015",
    "data-name": "Path 2015",
    className: "cls-1",
    d: "M23.56,24.81v.5H15.49v-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2025",
    "data-name": "Path 2025",
    className: "cls-1",
    d: "M23.56,22.76v.5H15.49v-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2026",
    "data-name": "Path 2026",
    className: "cls-1",
    d: "M15.48,19.17v-.5h8.08v.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2029",
    "data-name": "Path 2029",
    className: "cls-1",
    d: "M23.56,20.72v.5H15.49v-.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/ReportIcon.d0c1704b4b82300fc06d60e964eef1fb.svg";
export { ForwardRef as ReactComponent };